<template>
  <div v-if="copy">
    <h1>Task</h1>
    <div>
      <v-btn :to="computedPlannerLink"> <v-icon>event</v-icon>Planner </v-btn>
      <v-btn @click="deleteTask" color="error" v-if="task">
        <v-icon>delete</v-icon>Delete
      </v-btn>
      <MatterSearch
        :fileid="copy.fileid"
        @updateFile="updateFile"
        @unlink="unlink"
      />
    </div>
    <v-alert :value="true" color="info"
      >Enter the task details using form below</v-alert
    >
    <v-form ref="formTask" v-model="valid" lazy-validation>
      <DateDropdown label="Date" v-model="copy.customdate" />
      <v-text-field label="Title" v-model="title" :rules="valueRules" outline />
      <v-textarea label="Description" v-model="copy.description" outline />
      <v-select
        label="Reminder"
        v-model="copy.reminder"
        :items="reminders"
        item-value="id"
        item-text="text"
        outline
      />
      <v-checkbox label="Dismiss" v-model="copy.dismiss" />
      <v-select
        v-model="selectedEntities"
        :items="computedConveyancers"
        item-value="id"
        item-text="nameFormatted"
        attach
        chips
        label="Conveyancers"
        multiple
        outline
      />
      <v-btn @click="saveTask"> <v-icon>save</v-icon>Save </v-btn>
    </v-form>
    <v-snackbar
      v-model="snackbar"
      :multi-line="true"
      :timeout="3000"
      :top="true"
    >
      {{ snackbarText }}
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import DateDropdown from "@/components/date/DateDropdown";
import MatterSearch from "@/components/file/matter/MatterSearch.vue";
import { nameFormatted } from "@/util/helpers";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Task",
  metaInfo() {
    return {
      title: "Task",
      titleTemplate: "%s - Directory - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: { DateDropdown, MatterSearch },
  computed: {
    computedPlannerLink() {
      const customdate = new Date(this.copy.customdate);
      //   customdate.setDate(1);
      const start = customdate.toISOString().substr(0, 10);
      return { name: "planner", query: { start } };
    },
    computedConveyancers() {
      if (!this.conveyancers) {
        return [];
      }
      return this.conveyancers.map((c) => {
        return { ...c, nameFormatted: nameFormatted(c.name, "index") };
      });
    }
  },
  data() {
    return {
      task: null,
      copy: null,
      conveyancers: null,
      title: null,
      fileid: null,
      selectedEntities: [],
      reminders: [
        { id: 0, text: "No reminder" },
        { id: 1, text: "1 day" },
        { id: 2, text: "2 days" },
        { id: 3, text: "3 days" },
        { id: 4, text: "4 days" },
        { id: 5, text: "5 days" },
        { id: 6, text: "6 days" },
        { id: 7, text: "7 days" }
      ],
      valueRules: [(v) => !!v || "Value is required"],
      valid: false,
      snackbar: false,
      snackbarText: null
    };
  },
  methods: {
    async fetchTask() {
      const response = await nbmlaw.get(
        `/cors/admin/directory/entities/current/tasks/${this.$route.params.id}`
      );
      // console.log(response.data);
      this.task = response.data;
    },
    async fetchConveyancers() {
      const response = await nbmlaw.get(
        `/cors/admin/directory/types/2/entities`
      );
      // console.log(response.data);
      this.conveyancers = response.data;
    },
    saveTask() {
      if (this.$refs.formTask.validate()) {
        if (this.$route.params.id) {
          this.updateTask();
        } else {
          this.createTask();
        }
      }
    },
    async updateTask() {
      try {
        await nbmlaw.put(
          `/cors/admin/directory/entities/current/tasks/${this.$route.params.id}`,
          this.copy,
          {
            params: {
              title: this.title,
              selectedEntities: this.selectedEntities.join(".")
            }
          }
        );
        // console.log(response.data);
        this.$router.push(this.computedPlannerLink);
      } catch (err) {
        this.snackbar = true;
        this.snackbarText = err.response.data;
      }
    },
    async createTask() {
      try {
        const response = await nbmlaw.post(
          `/cors/admin/directory/entities/current/tasks`,
          this.copy,
          {
            params: {
              title: this.title,
              selectedEntities: this.selectedEntities.join(".")
            }
          }
        );
        // console.log(response.data);
        this.$router.push({ name: "task", params: { id: response.data } });
      } catch (err) {
        this.snackbar = true;
        this.snackbarText = err.response.data;
      }
    },
    async deleteTask() {
      if (confirm("Are you sure?")) {
        await nbmlaw.delete(
          `/cors/admin/directory/entities/current/tasks/${this.$route.params.id}`
        );
        // console.log(response.data);
        this.$router.push(this.computedPlannerLink);
      }
    },
    updateFile(id) {
      this.$set(this.copy, "fileid", parseInt(id));
    },
    unlink() {
      this.$set(this.copy, "fileid", null);
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        if (this.$route.params.id) {
          this.fetchTask();
        } else {
          this.copy = {
            customdate: new Date().toISOString().substr(0, 10),
            reminder: 1,
            fileid: this.$route.query.fileid
          };
          this.selectedEntities = [this.$keycloak.tokenParsed.entityid];
        }
      }
    },
    task: {
      handler() {
        if (this.task) {
          this.copy = JSON.parse(JSON.stringify(this.task));
          this.$set(
            this.copy,
            "fileid",
            this.task.file ? this.task.file.id : null
          );
          this.title = this.task.taskTitle ? this.task.taskTitle.body : null;
          this.selectedEntities = this.task.entities
            ? this.task.entities.map((c) => c.id)
            : [];
        }
      }
    }
  },
  created() {
    this.fetchConveyancers();
  }
};
</script>